import { Calendar } from "../../SharedModule/components/Calendar";
import { InputNumberHours } from "../../SharedModule/components/InputNumberHours";
import { Select } from "../../SharedModule/components/Select";
import { ReactNode, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectMetaTimesData } from "../redux/reducers/metaTimes.reducer";
import {
  EntryListView,
  TaskType,
  TimeEntryEditForm,
  TimeEntryForm,
  TimeEntryPostForm,
  TimeEntrySheetView,
} from "../types/times-module-types";
import {
  concatProjectsWorkOrders,
  empty,
  emptyProjectWorkOrder,
  getCategoryId,
  getProjectWorkOrder,
  getTaskCategoryName,
  getValueFromSelect,
  hasTimeAdminAccess,
  hasTimeViewerAccess,
  iconDeleteEnabled,
  setTimeEntryTypeIdforRequest,
} from "../utils/timesUtils";
import {
  computeEntryDateValidity,
  computeEntryDescriptionValidity,
  computeEntryHoursValidity,
  computeEntryIsBillableValidity,
  computeEntryNonBillableReasonValidity,
  computeEntryTaskTypeValidity,
  computeHoursValid,
  computeMealBreakProjectEntryValid,
  computeNonMealBreakProjectEntryValid,
  computeNonMealBreakProjectPatch,
  applyProjectWorkOrderTypeOverrides,
  computeEditFormFromEntry,
  computeImportedFromChangeGearOrBambooFlags,
  computeLoadPropsBaseState,
  computeLoadPropsEntryDateValid,
  computeMealBreakStateFromEntry,
  computeSaveDisabled,
  isRestrictedFutureMealOrNursingEdit,
  parseAddSaveResponse,
  parseEditSaveError,
} from "../utils/entryHoursBoxValidation";
import {
  IsSubmitted,
  setLoading,
  updateEntry,
} from "../redux/reducers/times.reducer";
import { TimesheetsService } from "../services/timesheets";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import {
  getDateFromISOFormat,
  getPreviousWorkableDay,
  isSameDay,
  isBetweenTwoDates,
  getLastWorkableDay,
  getIsoFormatStringWithTimeZone,
  getDateFromDateString,
} from "../../SharedModule/utils/dateUtils";
import { BiEditAlt, BiTrash, BiError, BiErrorCircle } from "react-icons/bi";
import {
  dateFormatEntryEdit,
  decodeURIComponentSafe,
} from "../../SharedModule/utils/formatters";
import {
  BAMBOO_HR,
  BENEFITS,
  CHANGE_GEAR,
  CLOUDFARE_ERROR,
  CLOUDFARE_ERROR_MESSAGE,
  INTERNAL_PROJECT,
  NONE,
  PROJ_MEAL_BREAK_ID,
  PROJ_NURSING_MOTHER_ID,
  PROJ_PAID_TIME_OFF_ID,
  PROJ_UNPAID_TIME_OFF_ID,
  STATUS_ERROR_FORBIDDEN,
  TASKTYPE_HOLIDAY_ID,
  TASKTYPE_MEAL_BREAK_ID,
  TASKTYPE_NURSING_MOTHER_ID,
  TASKTYPE_UNPAID_TIME_OFF_ID,
  TIME_OFF_SELF_VIEW_MESSAGE,
  UNPAID_TIME_OFF,
} from "../../SharedModule/utils/constants";
import {
  alreadyExistMealBreak,
  getIndexFromMealBreakHours,
  mealBreakHours,
} from "../utils/mealBreakHoursUtils";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import { Link } from "react-router";
import { UsersService } from "../../UsersModule/services/users";
import {
  hasSuperTimeAdminAccess,
  isSupervisorOrProjectOwner,
  isDeliveryTimeAdminChecker,
} from "../../SharedModule/utils/accessUtils";
import { generateHashTimeEntries } from "../utils/timeEntriesHelper";
import { FocusTrap } from "focus-trap-react";

export const EntryHoursBox = (props: any) => {
  const MetaTimesInfo = useSelector(selectMetaTimesData);

  const today = new Date();

  // need this value to calculate error of 24hs total
  const initialEntryHours = props.editMode ? props.state.entryHours : 0;

  let actualProjectsWorkOrders = props.projectsWorkOrders;
  let partialDescription = "";

  // to find taskTypecategoryId and isInternal
  let concatedSelectProjectOrWorkOrder = concatProjectsWorkOrders(
    props.projectsWorkOrders,
  );

  const { activeUserId, userRolesList } = useSelector(selectUserRoles);

  const isSubmitted = useSelector(IsSubmitted);

  const isTimeAdmin = hasTimeAdminAccess(userRolesList);
  const isSuperTimeAdmin = hasSuperTimeAdminAccess(userRolesList);
  const isSupervisorOrPO = isSupervisorOrProjectOwner(userRolesList);
  const isDeliveryTimeAdmin = isDeliveryTimeAdminChecker(userRolesList);
  const isTimeViewer = hasTimeViewerAccess(userRolesList);

  // ASUITE11-2876: Combine this two roles checker to avoid add OR in all conditions inside this component
  const isAnyOfSupervisorPoDelivery = isSupervisorOrPO || isDeliveryTimeAdmin;

  // ASUITE11-2418: Time Viewer Role - FE
  let disabledByTimeViewer =
    !isTimeAdmin && isTimeViewer && activeUserId !== props.userIdParam;

  // ASUITE11-2561: imported from changeGear or Bamboo and could not edit holidays
  const [
    isImportedFromChangeGearOrBamboo,
    setIsImportedFromChangeGearOrBamboo,
  ] = useState(
    props.activeEntry
      ? props.activeEntry.timeEntrySourceId === 3 ||
          (props.activeEntry.timeEntrySourceId === 2 &&
            props.activeEntry.taskTypeId !== TASKTYPE_HOLIDAY_ID) ||
          (props.activeEntry.timeEntrySourceId === 2 &&
            props.activeEntry.taskTypeId === TASKTYPE_HOLIDAY_ID &&
            !isSuperTimeAdmin) ||
          (props.activeEntry.timeEntrySourceId === 2 &&
            props.activeEntry.taskTypeId === TASKTYPE_HOLIDAY_ID &&
            isSuperTimeAdmin &&
            activeUserId === props.userIdParam)
      : false,
  );
  const [
    isImportedFromChangeGearOrBambooText,
    setIsImportedFromChangeGearOrBambooText,
  ] = useState(
    isImportedFromChangeGearOrBamboo &&
      props.activeEntry.timeEntrySourceId === 3
      ? CHANGE_GEAR
      : BAMBOO_HR,
  );

  // ASUITE11-2736: Time Admin: Delete imported time (from bamboo whan task type is PTO or UTO) for others
  const [deletableFromBambooSuperAdmin, setDeletableFromBambooSuperAdmin] =
    useState(
      props.activeEntry
        ? props.activeEntry.timeEntrySourceId === 2 &&
            isSuperTimeAdmin &&
            props.activeEntry.taskTypeId !== TASKTYPE_HOLIDAY_ID
        : false,
    );

  // In useState below, getTaskCategoryName was receive the entire element and not the value (taskTypesCategory)
  const getTaskTypesCategoryFromProjectWorkOrder = (value) => {
    let response = getProjectWorkOrder(concatedSelectProjectOrWorkOrder, value);
    return response?.taskTypesCategory;
  };

  const [actualTaskTypes, setActualTaskTypes] = useState<any>(
    props.state.entryProjectWorkOrder &&
      props.state.entryProjectWorkOrder.value !== 0
      ? MetaTimesInfo.taskTypes?.filter(
          (task: TaskType) =>
            task.category ===
            getTaskCategoryName(
              props.state.entryProjectWorkOrder.taskTypesCategory
                ? props.state.entryProjectWorkOrder.taskTypesCategory
                : getTaskTypesCategoryFromProjectWorkOrder(
                    props.state.entryProjectWorkOrder.value,
                  ),
            ),
        )
      : [],
  );

  const dispatch = useDispatch();

  let totalHoursActualDay = 0;

  const internalNonBillableReason = MetaTimesInfo.nonBillableReasons?.find(
    (elem) => elem.label === INTERNAL_PROJECT,
  );
  const unpaidTimeOffNonBillableReason = MetaTimesInfo.nonBillableReasons?.find(
    (elem) => elem.label === UNPAID_TIME_OFF,
  );
  const benefitsTimeOffNonBillableReason =
    MetaTimesInfo.nonBillableReasons?.find((elem) => elem.label === BENEFITS);

  const defaultTaskTypeNursingMother = getValueFromSelect(
    MetaTimesInfo.taskTypes,
    31,
  );

  // ASUITE11-2373: remove Benefits(8), Budget Exceeded(10), Unpaid Time Off(9) and ITX Investment: Internal Project(4) from the Non-Billable Reason dropdown
  const nonBillableReasonsAfterFilter =
    MetaTimesInfo.nonBillableReasons?.filter(
      (reason) => ![8, 10, 9, 4].includes(reason.value),
    );

  // task types when project is nursing mother: meal break, nursing mother
  const taskTypeNursingMother = MetaTimesInfo.taskTypes?.filter(
    (task) => task.value === 31,
  );

  const checkIsInternal = (value) => {
    let response = getProjectWorkOrder(concatedSelectProjectOrWorkOrder, value);
    return response?.isInternal;
  };

  const [isProjectWorkOrderInternal, setIsProjectWorkOrderInternal] = useState(
    props.state.entryProjectWorkOrder?.isInternal
      ? props.state.entryProjectWorkOrder.isInternal
      : props.state.entryProjectWorkOrder
        ? checkIsInternal(props.state.entryProjectWorkOrder.value)
        : false,
  );

  const [isMealBreak, setIsMealBreak] = useState(
    props.state.entryProjectWorkOrder?.value === PROJ_MEAL_BREAK_ID
      ? true
      : false,
  );

  let initialMealBreakHour =
    props.editMode && isMealBreak
      ? mealBreakHours[
          getIndexFromMealBreakHours(props.state.entryDescription, true)
        ]
      : mealBreakHours[48];
  let endMealBreakHour =
    props.editMode && isMealBreak
      ? mealBreakHours[
          getIndexFromMealBreakHours(props.state.entryDescription, false)
        ]
      : mealBreakHours[50];

  const [mealBreakState, setMealBreakState] = useState({
    start: initialMealBreakHour,
    end: endMealBreakHour,
  });

  const [previousMealBreakState, setPreviousMealBreakState] = useState(
    props.state.entryProjectWorkOrder?.value === PROJ_MEAL_BREAK_ID
      ? true
      : false,
  );

  const [isNursingMother, setIsNursingMother] = useState(
    props.state.entryProjectWorkOrder?.value === PROJ_NURSING_MOTHER_ID
      ? true
      : false,
  );

  // set task type options for each project
  const setOptionsTaskTypes = (option: number) => {
    setActualTaskTypes(
      MetaTimesInfo.taskTypes?.filter(
        (task: TaskType) => task.category === getTaskCategoryName(option),
      ),
    );
  };

  let previousWorkableDay = getPreviousWorkableDay(1, props.holidays);
  let lastWorkableDay: any = getLastWorkableDay();

  const [actualSourceUrl, setActualSourceUrl] = useState(
    props.editMode && props.activeEntry ? props.activeEntry.sourceUrl : null,
  );

  const loadPropsState = (incomingState: any) => {
    const loadPropsContext = {
      isSuperTimeAdmin,
      isAnyOfSupervisorPoDelivery,
      activeUserId,
      userIdParam: props.userIdParam,
      editMode: props.editMode,
      isModal: props.isModal,
      previousWorkableDay,
      lastWorkableDay,
      partialInactiveEntryProjectWorkOrder:
        props.partialInactiveEntryProjectWorkOrder,
      taskTypes: MetaTimesInfo.taskTypes,
      internalNonBillableReason,
      benefitsTimeOffNonBillableReason,
      unpaidTimeOffNonBillableReason,
      defaultTaskTypeNursingMother,
    };

    const entryDateValid = computeLoadPropsEntryDateValid(
      incomingState,
      loadPropsContext,
    );
    const baseState = computeLoadPropsBaseState(
      incomingState,
      entryDateValid,
      loadPropsContext,
    );
    return applyProjectWorkOrderTypeOverrides(
      baseState,
      incomingState,
      loadPropsContext,
    );
  };

  const [entryState, setEntryState] = useState(loadPropsState(props.state));

  const [isHolidayFromBamboo, setIsHolidayFromBamboo] = useState(
    props.isHolidayFromBamboo,
  );

  const loadTotalHoursActualDay = (date: string) => {
    totalHoursActualDay = 0;
    props.timeEntriesList
      .filter((entry) =>
        isSameDay(entry.entryDate, getDateFromDateString(date)),
      )
      .forEach((entry: EntryListView) => {
        totalHoursActualDay += entry.hours;
      });
  };
  loadTotalHoursActualDay(entryState.entryDate);

  const initialState: TimeEntryForm = {
    entryCanEdit: props.state.entryCanEdit,
    entryCanDelete: props.state.entryCanDelete,
    entryId: props.state.entryId,
    entryDate: props.state.entryDate,
    entryDateValid:
      isSuperTimeAdmin ||
      (isAnyOfSupervisorPoDelivery && activeUserId !== props.userIdParam) ||
      (previousWorkableDay <= new Date(props.state.entryDate) &&
        new Date(props.state.entryDate) < lastWorkableDay),
    entryProjectWorkOrder: emptyProjectWorkOrder,
    entryProjectWorkOrderValid: false,
    entryHours: "",
    entryHoursValid: false,
    entryTaskType: empty,
    entryTaskTypeValid: false,
    entryDescription: "",
    entryIsBillable: true,
    entryNonBillableReason: empty,
    entryNonBillableReasonValid: false,
    isEntryValid: false,
    isEntryTouched: false,
  };

  const [scheduledHours, setScheduledHours] = useState(null);

  // call endpoint to have page filters
  const getUserScheduledHours = async () => {
    let response = await UsersService.getUserDetails(props.userIdParam);
    setScheduledHours(response.data.scheduledHours);
  };

  // max hours allowed by user is equals to scheduledHours
  const maxHoursAllowed: number =
    isHolidayFromBamboo && scheduledHours ? scheduledHours : 24;

  const inputRef = useRef<undefined>(undefined);

  useEffect(() => {
    checkEntryValid();

    if (props.isHolidayFromBamboo && !scheduledHours) {
      getUserScheduledHours();
    }

    const handler = (event: any) => {
      if (event.keyCode === 13 && props.isModal) {
        if (
          document.activeElement?.tagName === "BUTTON" &&
          (document.activeElement.textContent === "Save" ||
            document.activeElement.textContent === "Save all entries") &&
          entryState.isEntryTouched &&
          entryState.isEntryValid
        ) {
          clickHandler();
        } else if (
          document.activeElement?.textContent !== "Cancel" &&
          document.activeElement?.textContent !== "Add new entries" &&
          document.activeElement?.textContent !== "Delete" &&
          !document.activeElement?.className.includes("react-calendar__tile")
        ) {
          event.preventDefault();
        }
      }
    };

    document.addEventListener("keydown", handler);

    return () => document.removeEventListener("keydown", handler);
  }, [entryState]);

  const checkEntryValid = () => {
    // edit entry on page times, not modal => update redux state
    if (!props.isModal) {
      dispatch(updateEntry({ entryState }));
    }

    if (entryState.isEntryValid && !props.isModal) {
      props.isTouched();
    }
  };

  const checkHoursValid = (value: any, project: any, task: any) =>
    computeHoursValid(value, project, task, {
      isMealBreak,
      editMode: props.editMode,
      totalHoursActualDay,
      initialEntryHours,
    });

  const handleChange = (value, property) => {
    let isFieldValid;
    let actualEntryValid;
    let actualhoursEntryValid = false;
    let firstTimeMealBreakHoursValid;
    let mealBreakNewHours;

    // ASUITE11-2507: meal break or nursing older than today for superadmin/supervisor/PO/delivery for other
    let checkFutureMealOrNursing = isRestrictedFutureMealOrNursingEdit(
      entryState.entryDate,
      isMealBreakOrNursing(),
      today,
      isSuperTimeAdmin,
      isAnyOfSupervisorPoDelivery,
      activeUserId,
      props.userIdParam,
    );

    switch (property) {
      case "entryProjectWorkOrder": {
        isFieldValid =
          value.label !== emptyProjectWorkOrder.label &&
          value.value !== emptyProjectWorkOrder.value;

        setOptionsTaskTypes(value.taskTypesCategory);

        if (value.isInternal) {
          setIsProjectWorkOrderInternal(true);
        } else {
          setIsProjectWorkOrderInternal(false);
        }

        if (value.value === PROJ_MEAL_BREAK_ID) {
          setIsMealBreak(true);
          setPreviousMealBreakState(true);
          setIsNursingMother(false);

          mealBreakNewHours = updateMealBreakHours(
            mealBreakHours[48],
            "start",
            false,
          );
          firstTimeMealBreakHoursValid = true;
          actualhoursEntryValid = true;

          const existMealBreak: any = props.timeEntriesList
            .filter((elem) => elem.entityId === PROJ_MEAL_BREAK_ID)
            .find((elem) =>
              isSameDay(elem.entryDate, new Date(entryState.entryDate)),
            );

          // ASUITE11-2507: meal break or nursing older than today for superadmin/supervisor/PO/delivery for other
          const checkFutureMealBreak = isRestrictedFutureMealOrNursingEdit(
            entryState.entryDate,
            true,
            today,
            isSuperTimeAdmin,
            isAnyOfSupervisorPoDelivery,
            activeUserId,
            props.userIdParam,
          );

          actualEntryValid = computeMealBreakProjectEntryValid(
            isFieldValid,
            entryState.entryDateValid,
            !!existMealBreak,
            checkFutureMealBreak,
            entryState.entryHoursValid,
          );

          setEntryState({
            ...entryState,
            [property]: { value: value.value, label: value.label },
            entryProjectWorkOrderValid: isFieldValid,
            entryIsBillable: false,
            entryHours: mealBreakNewHours
              ? mealBreakNewHours
              : entryState.entryHours,
            entryHoursValid: actualhoursEntryValid
              ? actualhoursEntryValid
              : entryState.entryHoursValid,
            entryNonBillableReason: unpaidTimeOffNonBillableReason,
            entryNonBillableReasonValid: true,
            entryTaskType: !!value.defaultTaskTypeId
              ? getValueFromSelect(
                  MetaTimesInfo.taskTypes,
                  value.defaultTaskTypeId,
                )
              : empty,
            entryTaskTypeValid: !!value.defaultTaskTypeId,
            entryDescription: partialDescription,
            isEntryTouched: true,
            isEntryValid: actualEntryValid,
          });
        } else {
          setIsMealBreak(false);
          setPreviousMealBreakState(false);

          // Should eval hours after change project, for example is has a default task type
          actualhoursEntryValid = checkHoursValid(
            entryState.entryHours,
            value,
            entryState.entryTaskType,
          );

          const isNursingMother = value.value === PROJ_NURSING_MOTHER_ID;
          setIsNursingMother(isNursingMother);

          // ASUITE11-2507: meal break or nursing older than today for superadmin/supervisor/PO/delivery for other
          const checkFutureNursing = isNursingMother
            ? isRestrictedFutureMealOrNursingEdit(
                entryState.entryDate,
                true,
                today,
                isSuperTimeAdmin,
                isAnyOfSupervisorPoDelivery,
                activeUserId,
                props.userIdParam,
              )
            : false;

          actualEntryValid = computeNonMealBreakProjectEntryValid(
            entryState,
            value,
            isFieldValid,
            actualhoursEntryValid,
            previousMealBreakState,
            isNursingMother,
            checkFutureNursing,
          );

          const projectPatch = computeNonMealBreakProjectPatch(
            entryState,
            value,
            actualhoursEntryValid,
            previousMealBreakState,
            {
              nonBillableReasons: MetaTimesInfo.nonBillableReasons,
              taskTypes: MetaTimesInfo.taskTypes,
              nursingMotherReason: benefitsTimeOffNonBillableReason,
              internalReason: internalNonBillableReason,
              nursingMotherTaskType: defaultTaskTypeNursingMother,
            },
          );

          setEntryState({
            ...entryState,
            entryProjectWorkOrderValid: isFieldValid,
            isEntryTouched: true,
            isEntryValid: actualEntryValid,
            [property]: { value: value.value, label: value.label },
            ...projectPatch,
          });
        }
        break;
      }
      case "entryDate": {
        const existMealBreak: any = isMealBreak
          ? props.timeEntriesList
              .filter((elem) => elem.entityId === PROJ_MEAL_BREAK_ID)
              .find((elem) => isSameDay(elem.entryDate, new Date(value)))
          : false;

        // recalculate sum of totals hours of all entries
        loadTotalHoursActualDay(value);

        isFieldValid =
          isSuperTimeAdmin ||
          (isAnyOfSupervisorPoDelivery && activeUserId !== props.userIdParam)
            ? true
            : previousWorkableDay <= new Date(value) &&
              new Date(value) < lastWorkableDay;

        // ASUITE11-2507: meal break or nursing older than today for superadmin/supervisor/PO/delivery for other
        const checkFutureMealOrNursingOnDate = isRestrictedFutureMealOrNursingEdit(
          value,
          isMealBreakOrNursing(),
          today,
          isSuperTimeAdmin,
          isAnyOfSupervisorPoDelivery,
          activeUserId,
          props.userIdParam,
        );

        const entryDateResult = computeEntryDateValidity(
          entryState,
          isFieldValid,
          {
            isMealBreak,
            editMode: props.editMode,
            totalHoursActualDay,
            initialEntryHours,
          },
          !!existMealBreak,
          checkFutureMealOrNursingOnDate,
        );
        actualhoursEntryValid = entryDateResult.actualhoursEntryValid;
        actualEntryValid = entryDateResult.actualEntryValid;

        setEntryState({
          ...entryState,
          [property]: value,
          entryDateValid: isFieldValid,
          entryHoursValid: actualhoursEntryValid,
          isEntryTouched: true,
          isEntryValid: actualEntryValid,
        });
        if (event?.type === "click") {
          requestAnimationFrame(() => {
            (inputRef.current as any)?.focus?.();
          });
        }
        break;
      }
      case "entryHours": {
        const entryHoursResult = computeEntryHoursValidity(
          entryState,
          value,
          {
            isMealBreak,
            editMode: props.editMode,
            totalHoursActualDay,
            initialEntryHours,
          },
          checkFutureMealOrNursing,
        );
        isFieldValid = entryHoursResult.isFieldValid;
        actualEntryValid = entryHoursResult.actualEntryValid;
        setEntryState({
          ...entryState,
          [property]: value,
          entryHoursValid: isFieldValid,
          isEntryTouched: true,
          isEntryValid: actualEntryValid,
          entryDescription: isMealBreak
            ? partialDescription
            : entryState.entryDescription,
        });
        break;
      }
      case "entryTaskType": {
        // ASUITE11-2507: meal break or nursing older than today for superadmin/supervisor/PO/delivery for other
        const checkMealOrNursing = isRestrictedFutureMealOrNursingEdit(
          entryState.entryDate,
          value.value === TASKTYPE_NURSING_MOTHER_ID ||
            value.value === TASKTYPE_MEAL_BREAK_ID,
          today,
          isSuperTimeAdmin,
          isAnyOfSupervisorPoDelivery,
          activeUserId,
          props.userIdParam,
        );

        const taskTypeResult = computeEntryTaskTypeValidity(
          entryState,
          value,
          {
            isMealBreak,
            editMode: props.editMode,
            totalHoursActualDay,
            initialEntryHours,
          },
          checkMealOrNursing,
          {
            nursingMother: benefitsTimeOffNonBillableReason,
            unpaidOrMealBreak: unpaidTimeOffNonBillableReason,
          },
        );
        isFieldValid = taskTypeResult.isFieldValid;
        actualhoursEntryValid = taskTypeResult.actualhoursEntryValid;
        actualEntryValid = taskTypeResult.actualEntryValid;

        setEntryState({
          ...entryState,
          [property]: value,
          entryTaskTypeValid: isFieldValid,
          isEntryTouched: true,
          isEntryValid: taskTypeResult.isEntryValid,
          entryNonBillableReason: taskTypeResult.entryNonBillableReason,
          entryNonBillableReasonValid:
            taskTypeResult.entryNonBillableReasonValid,
          entryHoursValid: taskTypeResult.entryHoursValid,
        });
        break;
      }
      case "entryDescription":
        isFieldValid = true;
        actualEntryValid = computeEntryDescriptionValidity(
          entryState,
          checkFutureMealOrNursing,
        );
        setEntryState({
          ...entryState,
          [property]: value,
          isEntryTouched: true,
          isEntryValid: actualEntryValid,
        });
        break;
      case "entryNonBillableReason": {
        const nonBillableReasonResult = computeEntryNonBillableReasonValidity(
          entryState,
          value,
          checkFutureMealOrNursing,
        );
        isFieldValid = nonBillableReasonResult.isFieldValid;
        actualEntryValid = nonBillableReasonResult.actualEntryValid;
        setEntryState({
          ...entryState,
          [property]: value,
          entryNonBillableReasonValid: isFieldValid,
          isEntryTouched: true,
          isEntryValid: actualEntryValid,
        });
        break;
      }
      case "entryIsBillable": {
        const isBillableResult = computeEntryIsBillableValidity(
          entryState,
          value,
          checkFutureMealOrNursing,
        );
        actualEntryValid = isBillableResult.actualEntryValid;
        setEntryState({
          ...entryState,
          [property]: value,
          isEntryTouched: true,
          isEntryValid: actualEntryValid,
          entryNonBillableReasonValid:
            isBillableResult.entryNonBillableReasonValid,
        });
        break;
      }
      default:
        break;
    }
  };

  const saveAction = async () => {
    let request: TimeEntryPostForm[] = [];
    let bodyEdit: TimeEntryEditForm;
    let avoidResetPage: boolean = false;

    let newHash = generateHashTimeEntries(
      entryState.entryDate.split("T")[0],
      activeUserId,
    );

    if (props.editMode) {
      // services to edit
      bodyEdit = {
        entryDate: entryState.entryDate,
        hours: entryState.entryHours,
        taskTypeId: entryState.entryTaskType.value,
        description: isMealBreak
          ? mealBreakState.start && mealBreakState.end
            ? mealBreakState.start.value + " to " + mealBreakState.end.value
            : entryState.entryDescription
          : entryState.entryDescription.length === 0
            ? NONE
            : encodeURIComponent(entryState.entryDescription),
        entityId: entryState.entryProjectWorkOrder.value,
        timeEntryCategoryId: getCategoryId(
          concatProjectsWorkOrders(actualProjectsWorkOrders),
          entryState.entryProjectWorkOrder.value,
        ),
        timeEntryTypeId: setTimeEntryTypeIdforRequest(entryState),
        // could be non billable from BE, so sometimes entryNonBillableReason still empty on entry nonBillable
        nonBillableReasonId: entryState.entryIsBillable
          ? null
          : entryState.entryNonBillableReason.value
            ? entryState.entryNonBillableReason.value
            : null,
        timeEntrySignature: newHash,
      };

      props.btnCancel();
      dispatch(setLoading(true));
      await TimesheetsService.editTimesEntry(bodyEdit, entryState.entryId)
        .then((response) => {
          dispatch(
            addToast({ mode: "success", message: response.data.message }),
          );
          if (!props.isQueryPage) {
            props.resetPage();
          }
          props.reloadPage(entryState.entryDate);
        })
        .catch((err: any) => {
          const canShowBanner = !!props.showBackendEntryError;
          const { isClientPriceLevelError, toastMessage, backendBannerMessage } =
            parseEditSaveError(err, canShowBanner);

          dispatch(addToast({ mode: "error", message: toastMessage }));
          if (isClientPriceLevelError) {
            props.showClientPriceLevelError();
          }

          // ASUITE11-4337: refresh so the summary skeleton clears (setLoading
          // false alone doesn't reset isSummaryLoading), then apply the banner.
          if (!props.isQueryPage) {
            props.reloadPage(entryState.entryDate);
          } else {
            dispatch(setLoading(false));
          }
          if (backendBannerMessage) {
            props.showBackendEntryError([backendBannerMessage]);
          }
        });
    } else {
      // replicates services to add in time pages
      request.push({
        userId: props.userIdParam,
        entryDate: entryState.entryDate,
        hours: Number(entryState.entryHours),
        taskTypeId: entryState.entryTaskType.value,
        description: isMealBreak
          ? mealBreakState.start.value + " to " + mealBreakState.end.value
          : entryState.entryDescription.length === 0
            ? NONE
            : encodeURIComponent(entryState.entryDescription),
        entityId: entryState.entryProjectWorkOrder.value,
        timeEntryCategoryId: getCategoryId(
          concatProjectsWorkOrders(actualProjectsWorkOrders),
          entryState.entryProjectWorkOrder.value,
        ),
        timeEntryTypeId: setTimeEntryTypeIdforRequest(entryState),
        timeEntrySourceId: 1,
        nonBillableReasonId: entryState.entryIsBillable
          ? null
          : entryState.entryNonBillableReason.value,
        timeEntrySignature: newHash,
      });

      props.btnCancel();
      dispatch(setLoading(true));
      await TimesheetsService.addTimesEntries(request)
        .then((response) => {
          // ASUITE11-4337: specific reason to push to the page banner AFTER the
          // page reset/reload below, so it isn't wiped by them.
          const canShowBanner = !!props.showBackendEntryError;
          const {
            toastMode,
            toastMessage,
            isClientPriceLevelError,
            backendBannerMessage,
          } = parseAddSaveResponse(response, canShowBanner);

          dispatch(addToast({ mode: toastMode, message: toastMessage }));
          if (isClientPriceLevelError) {
            avoidResetPage = true;
            props.showClientPriceLevelError();
          }

          if (!props.isQueryPage && !avoidResetPage) {
            props.resetPage();
          }
          if (!avoidResetPage) {
            props.reloadPage(entryState.entryDate);
          } else {
            dispatch(setLoading(false));
          }
          if (backendBannerMessage) {
            props.showBackendEntryError([backendBannerMessage]);
          }
        })
        .catch((err) => {
          dispatch(
            addToast({
              mode: "error",
              message:
                err.response.status === STATUS_ERROR_FORBIDDEN &&
                err.response.data.includes(CLOUDFARE_ERROR)
                  ? CLOUDFARE_ERROR_MESSAGE
                  : err.response.data.error ||
                    "An error ocurred trying to perform operation",
            }),
          );
          dispatch(setLoading(false));
        });
    }
  };

  // on click in percil when multiples time entries in a cell
  const updateInfoModal = (entry: TimeEntrySheetView) => {
    const importedFlags = computeImportedFromChangeGearOrBambooFlags(
      entry,
      isSuperTimeAdmin,
      activeUserId,
      props.userIdParam,
      isImportedFromChangeGearOrBamboo,
    );
    setIsImportedFromChangeGearOrBamboo(
      importedFlags.isImportedFromChangeGearOrBamboo,
    );
    setIsImportedFromChangeGearOrBambooText(
      importedFlags.isImportedFromChangeGearOrBambooText,
    );
    setDeletableFromBambooSuperAdmin(
      importedFlags.deletableFromBambooSuperAdmin,
    );
    setIsHolidayFromBamboo(importedFlags.isHolidayFromBamboo);

    const mealBreakState = computeMealBreakStateFromEntry(entry);
    if (mealBreakState) {
      setMealBreakState(mealBreakState);
    }

    const newEditForm = computeEditFormFromEntry(entry, isSuperTimeAdmin, {
      projectsWorkOrders: concatProjectsWorkOrders(actualProjectsWorkOrders),
      partialInactiveEntryProjectWorkOrder:
        props.partialInactiveEntryProjectWorkOrder,
      taskTypes: MetaTimesInfo.taskTypes,
      nonBillableReasons: MetaTimesInfo.nonBillableReasons,
    });

    setActualSourceUrl(entry.sourceUrl);
    setEntryState(newEditForm);
  };

  // Sheet view save - modal (add/edit)
  const clickHandler = () => {
    // if entry is valid => save, if not modal still present
    if (entryState.isEntryValid) {
      saveAction();
    }
  };

  const handleClear = () => {
    setEntryState(initialState);
    setIsProjectWorkOrderInternal(false);
    setIsMealBreak(false);
    props.onClear(initialState.entryId);
  };

  const checkTotalHours = () => {
    if (props.editMode) {
      return (
        Number(entryState.entryHours) +
          totalHoursActualDay -
          initialEntryHours >
        24
      );
    } else {
      return Number(entryState.entryHours) + totalHoursActualDay > 24;
    }
  };

  const updateMealBreakHours = (
    value: any,
    type: string,
    shouldUpdateState: boolean,
  ) => {
    let index = mealBreakHours.indexOf(value);
    let newHours = 0;
    if (type === "start") {
      newHours = 0.5;
      setMealBreakState({
        start: value,
        end: mealBreakHours[index + 2],
      });
    } else {
      let indexStart = mealBreakHours.indexOf(mealBreakState.start);
      newHours = (index - indexStart) * 0.25;
      setMealBreakState({
        ...mealBreakState,
        end: value,
      });
    }

    partialDescription =
      type === "start"
        ? value.value + " to " + mealBreakHours[index + 2].value
        : mealBreakState.start.value + " to " + value.value;

    if (shouldUpdateState) {
      handleChange(newHours, "entryHours");
    } else {
      return newHours;
    }
  };

  const isEntryTimeOffValid = (entry: TimeEntryForm) => {
    let isTimeoff =
      entry.entryProjectWorkOrder.value === PROJ_PAID_TIME_OFF_ID ||
      (entry.entryProjectWorkOrder.value === PROJ_UNPAID_TIME_OFF_ID &&
        entry.entryTaskType.value === TASKTYPE_UNPAID_TIME_OFF_ID);
    return (
      !isTimeoff ||
      (isTimeoff && activeUserId !== props.userIdParam && isSuperTimeAdmin)
    );
  };

  const isMealBreakOrNursing = () => {
    return (
      entryState.entryTaskType.value === TASKTYPE_MEAL_BREAK_ID ||
      entryState.entryTaskType.value === TASKTYPE_NURSING_MOTHER_ID ||
      entryState.entryProjectWorkOrder.value === PROJ_MEAL_BREAK_ID ||
      entryState.entryProjectWorkOrder.value === PROJ_NURSING_MOTHER_ID
    );
  };

  const setSaveDisabled = () =>
    computeSaveDisabled(entryState, {
      partialInactiveEntryProjectWorkOrder:
        props.partialInactiveEntryProjectWorkOrder,
      editMode: props.editMode,
      isHolidayFromBamboo,
      maxHoursAllowed,
      alreadyExistsMealBreak: alreadyExistMealBreak(
        entryState,
        props.timeEntriesList,
      ),
      isEntryTimeOffValid: isEntryTimeOffValid(entryState),
      isSuperTimeAdmin,
      isMealBreakOrNursing: isMealBreakOrNursing(),
      previousWorkableDay,
      today,
      activeUserId,
      userIdParam: props.userIdParam,
      lastWorkableDay,
      isAnyOfSupervisorPoDelivery,
      isImportedFromChangeGearOrBamboo,
      disabledByTimeViewer,
    });

  let modalContent: ReactNode = (
    <div>
      <div className={`row ${props.isModal ? "mt-3" : ""}`}>
        <div
          className="d-flex flex-column col-sm-3"
          style={{ maxWidth: "220px" }}
        >
          <label htmlFor="entry-date" className="col-form-label">
            Date
          </label>
          <Calendar
            id="entry-date"
            tabIndex={0}
            className={`me-3 modalCalendar ${
              entryState.isEntryTouched &&
              isSubmitted &&
              !entryState.entryDateValid
                ? "border-error"
                : ""
            }`}
            date={entryState.entryDate}
            onChange={(value) => handleChange(value, "entryDate")}
            minDate={
              isSuperTimeAdmin ||
              (isAnyOfSupervisorPoDelivery &&
                activeUserId !== props.userIdParam)
                ? undefined
                : previousWorkableDay
            }
            maxDate={
              isSuperTimeAdmin ||
              (isAnyOfSupervisorPoDelivery &&
                activeUserId !== props.userIdParam)
                ? undefined
                : lastWorkableDay
            }
            isDisabled={
              !MetaTimesInfo.timesDataLoaded ||
              (props.editMode &&
                (!isTimeAdmin ||
                  (isAnyOfSupervisorPoDelivery &&
                    activeUserId === props.userIdParam &&
                    !isSuperTimeAdmin)) &&
                getDateFromISOFormat(
                  getIsoFormatStringWithTimeZone(previousWorkableDay),
                ) >
                  getDateFromISOFormat(
                    getIsoFormatStringWithTimeZone(
                      new Date(props.state.entryDate),
                    ),
                  )) ||
              isImportedFromChangeGearOrBamboo ||
              props.partialInactiveEntryProjectWorkOrder ||
              props.addMealBreakFromListView ||
              !entryState.entryCanEdit ||
              disabledByTimeViewer
            }
          />
          {!entryState.entryDateValid &&
            (entryState.entryCanEdit || !isImportedFromChangeGearOrBamboo) && (
              <div className="error-message">
                <BiError className="error-icon" />
                <span className="ms-1">{`${
                  new Date(entryState.entryDate) < previousWorkableDay
                    ? "You cannot enter time past the last working day"
                    : "You cannot enter time further than this week"
                }`}</span>
              </div>
            )}
        </div>
        <div
          className={`d-flex flex-column ${
            !isMealBreak ? "col-sm-7" : "col-sm-3"
          }`}
          style={{ flexGrow: "1" }}
        >
          <label htmlFor="entry-project-work-order" className="col-form-label">
            Project / Work order
          </label>
          <Select
            inputId="entry-project-work-order"
            ref={inputRef}
            tabIndex={0}
            className={`me-3 ${
              entryState.isEntryTouched &&
              isSubmitted &&
              !entryState.entryProjectWorkOrderValid
                ? "select-border-error"
                : ""
            }`}
            placeholder="Select a project, task or work order you are assigned to"
            options={actualProjectsWorkOrders}
            value={entryState.entryProjectWorkOrder}
            onChange={(project) =>
              handleChange(project, "entryProjectWorkOrder")
            }
            isDisabled={
              props.isLoadingProjects ||
              !MetaTimesInfo.timesDataLoaded ||
              isHolidayFromBamboo ||
              isImportedFromChangeGearOrBamboo ||
              props.partialInactiveEntryProjectWorkOrder ||
              props.addMealBreakFromListView ||
              !entryState.entryCanEdit ||
              disabledByTimeViewer
            }
          />
          {entryState.isEntryTouched &&
            isSubmitted &&
            !entryState.entryProjectWorkOrderValid && (
              <div className="error-message">
                <BiError className="error-icon" />
                <span className="ms-1">Select project or work order</span>
              </div>
            )}
          {!isBetweenTwoDates(entryState.entryDate, null, today) &&
            isMealBreakOrNursing() &&
            ((isSuperTimeAdmin && activeUserId !== props.userIdParam) ||
              (isAnyOfSupervisorPoDelivery &&
                activeUserId !== props.userIdParam)) && (
              <div className="error-message">
                <BiError className="error-icon" />
                <span className="ms-1">
                  You cannot enter this type of time in the future
                </span>
              </div>
            )}
          {/* ASUITE11-4363: time-off project excluded from the viewer's own list
              by design — inform instead of showing a misleading "(INACTIVE)". */}
          {props.timeOffExcludedFromView && (
            <div className="card-meal-break my-3 d-flex flex-row">
              <BiErrorCircle className="meal-break-box-icon blue-text" />
              <span className="p-3">{TIME_OFF_SELF_VIEW_MESSAGE}</span>
            </div>
          )}
        </div>
        {!isMealBreak && (
          <div
            className="d-flex flex-column col-sm-2"
            style={{ maxWidth: "220px" }}
          >
            <label htmlFor="InputNumberHours" className="col-form-label">
              Hours
            </label>
            <InputNumberHours
              id="InputNumberHours"
              autoFocus={props.isModal}
              className={`me-3 ${
                (entryState.isEntryTouched &&
                  isSubmitted &&
                  !entryState.entryHoursValid) ||
                checkTotalHours()
                  ? "border-error"
                  : ""
              }`}
              hours={entryState.entryHours}
              setHours={(value) => handleChange(value, "entryHours")}
              disabled={
                isImportedFromChangeGearOrBamboo ||
                props.partialInactiveEntryProjectWorkOrder ||
                !entryState.entryCanEdit ||
                disabledByTimeViewer
              }
            />
            {entryState.isEntryTouched &&
              isSubmitted &&
              !entryState.entryHoursValid &&
              !checkTotalHours() && (
                <div className="error-message">
                  <BiError className="error-icon" />
                  <span className="ms-1">{`${
                    entryState.entryHours === 0 || entryState.entryHours === ""
                      ? "Must be between 0.25 and 24 hours"
                      : entryState.entryProjectWorkOrder.value ===
                            PROJ_UNPAID_TIME_OFF_ID &&
                          entryState.entryTaskType.value ===
                            TASKTYPE_MEAL_BREAK_ID &&
                          Number(entryState.entryHours) > 1
                        ? "Meal break cannot exceed 1 hour"
                        : "Needs to be multiple of 0.25"
                  }`}</span>
                </div>
              )}
            {checkTotalHours() && (
              <div className="error-message">
                <BiError className="error-icon" />
                <span className="ms-1">Exceeds 24 in a day</span>
              </div>
            )}
            {isHolidayFromBamboo &&
              maxHoursAllowed < Number(entryState.entryHours) && (
                <div className="error-message">
                  <BiError className="error-icon" />
                  <span className="ms-1">
                    Hours: Can only be lower than the original imported
                  </span>
                </div>
              )}
          </div>
        )}
        {isMealBreak && (
          <>
            <div
              className="d-flex flex-column col-sm-3"
              style={{ maxWidth: "220px" }}
            >
              <label htmlFor="meal-break-start" className="col-form-label">
                Meal break start
              </label>
              <Select
                inputId="meal-break-start"
                className="me-3 has-clock-icon"
                options={mealBreakHours}
                value={mealBreakState.start}
                onChange={(value) => updateMealBreakHours(value, "start", true)}
                hasClockIcon={true}
                isDisabled={
                  isImportedFromChangeGearOrBamboo ||
                  !entryState.entryCanEdit ||
                  disabledByTimeViewer
                }
                placeholder=""
              />
            </div>
            <div
              className="d-flex flex-column col-sm-3"
              style={{ maxWidth: "220px" }}
            >
              <label htmlFor="meal-break-end" className="col-form-label">
                Meal break end
              </label>
              <Select
                inputId="meal-break-end"
                className="me-3 has-clock-icon"
                options={mealBreakHours}
                value={mealBreakState.end}
                onChange={(value) => updateMealBreakHours(value, "end", true)}
                hasClockIcon={true}
                isDisabled={
                  isImportedFromChangeGearOrBamboo ||
                  !entryState.entryCanEdit ||
                  disabledByTimeViewer
                }
                placeholder=""
              />
              {isMealBreak &&
                !entryState.isEntryValid &&
                entryState.entryDateValid &&
                isBetweenTwoDates(entryState.entryDate, null, today) && (
                  <div className="error-message">
                    <BiError className="error-icon" />
                    <span className="ms-1">
                      {!entryState.entryHoursValid
                        ? "Meal break cannot exceed 1 hour"
                        : "Only one meal break is allowed per day"}
                    </span>
                  </div>
                )}
            </div>
          </>
        )}
      </div>
      {isMealBreak && (
        <div className="card-meal-break my-3 d-flex flex-row">
          <BiErrorCircle className="meal-break-box-icon blue-text" />
          <span className="blue-text px-2 py-3">Meal Break</span>
          <span className="p-3">
            Non-exempt who work more than 6 hours in a day are required to take
            an unpaid, uninterrupted meal break of 30 minutes per ITX's
            established policies. Meal breaks are not counted toward hours
            worked. All non-exempt employees are required to track and record
            these breaks. Please enter the start and end time of your break.
          </span>
        </div>
      )}
      {!isMealBreak && (
        <div className="row mt-3">
          <div
            className="d-flex flex-column col-sm-3"
            style={{ maxWidth: "220px" }}
          >
            <label htmlFor="entry-task-type" className="col-form-label">
              Task type
            </label>
            <Select
              inputId="entry-task-type"
              tabIndex={0}
              className={`me-3 ${
                entryState.isEntryTouched &&
                isSubmitted &&
                !entryState.entryTaskTypeValid
                  ? "select-border-error"
                  : ""
              }`}
              options={
                isNursingMother ? taskTypeNursingMother : actualTaskTypes
              }
              value={entryState.entryTaskType}
              onChange={(value) => handleChange(value, "entryTaskType")}
              isDisabled={
                !MetaTimesInfo.timesDataLoaded ||
                isHolidayFromBamboo ||
                isImportedFromChangeGearOrBamboo ||
                props.partialInactiveEntryProjectWorkOrder ||
                !entryState.entryCanEdit ||
                disabledByTimeViewer
              }
            />
            {entryState.isEntryTouched &&
              isSubmitted &&
              !entryState.entryTaskTypeValid && (
                <div className="error-message">
                  <BiError className="error-icon" />
                  <span className="ms-1">Select task type</span>
                </div>
              )}
            {isTimeAdmin && (
              <>
                <div className="d-flex mt-4">
                  <input
                    tabIndex={0}
                    className="form-check-input"
                    id="billable"
                    type="checkbox"
                    checked={entryState.entryIsBillable}
                    disabled={
                      isProjectWorkOrderInternal ||
                      isHolidayFromBamboo ||
                      isImportedFromChangeGearOrBamboo ||
                      props.partialInactiveEntryProjectWorkOrder ||
                      !entryState.entryCanEdit ||
                      disabledByTimeViewer
                    }
                    onChange={(e) =>
                      handleChange(e.target.checked, "entryIsBillable")
                    }
                  />
                  <label htmlFor="billable" className="form-check-label ms-3">
                    Billable
                  </label>
                </div>
                {(!entryState.entryIsBillable ||
                  entryState.entryProjectWorkOrder?.isInternal) && (
                  <div className="row mt-3">
                    <div
                      className="d-flex flex-column"
                      style={{ maxWidth: "220px" }}
                    >
                      <label
                        htmlFor="entry-non-billable-reason"
                        className="col-form-label"
                      >
                        Non-billable reason
                      </label>
                      <Select
                        inputId="entry-non-billable-reason"
                        tabIndex={0}
                        className={`me-3 ${
                          entryState.isEntryTouched &&
                          isSubmitted &&
                          !entryState.entryNonBillableReasonValid
                            ? "select-border-error"
                            : ""
                        }`}
                        options={nonBillableReasonsAfterFilter}
                        value={entryState.entryNonBillableReason}
                        onChange={(value) =>
                          handleChange(value, "entryNonBillableReason")
                        }
                        isDisabled={
                          isProjectWorkOrderInternal ||
                          !MetaTimesInfo.timesDataLoaded ||
                          isHolidayFromBamboo ||
                          isImportedFromChangeGearOrBamboo ||
                          props.partialInactiveEntryProjectWorkOrder ||
                          !entryState.entryCanEdit ||
                          disabledByTimeViewer
                        }
                      />
                    </div>
                    {entryState.isEntryTouched &&
                      isSubmitted &&
                      !entryState.entryNonBillableReasonValid && (
                        <div className="error-message">
                          <BiError className="error-icon" />
                          <span className="ms-1">
                            Select Non-billable reason
                          </span>
                        </div>
                      )}
                  </div>
                )}
              </>
            )}
          </div>
          <div
            className="d-flex flex-column col-sm-9"
            style={{ flexGrow: "1" }}
          >
            <label htmlFor="entry-description" className="col-form-label">
              Description
            </label>
            <TextareaAutosize
              id="entry-description"
              tabIndex={0}
              minRows={3}
              maxRows={6}
              maxLength={4000}
              className={`textarea-entry-box ${
                isHolidayFromBamboo ||
                isImportedFromChangeGearOrBamboo ||
                props.partialInactiveEntryProjectWorkOrder
                  ? "disabled"
                  : ""
              }`}
              placeholder="—"
              value={entryState.entryDescription}
              onChange={(e) => handleChange(e.target.value, "entryDescription")}
              disabled={
                isHolidayFromBamboo ||
                isImportedFromChangeGearOrBamboo ||
                props.partialInactiveEntryProjectWorkOrder ||
                !entryState.entryCanEdit ||
                disabledByTimeViewer
              }
            />
          </div>
        </div>
      )}
      <div className="row mt-4">
        {!props.isModal && (
          <div
            role="button"
            tabIndex={0}
            className="clear-button pe-4"
            onClick={() => handleClear()}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClear();
              }
            }}
          >
            Clear
          </div>
        )}
        {props.isModal && (
          <div
            className="d-flex justify-content-between"
            style={{ height: "40px" }}
          >
            <div>
              {props.editMode &&
                !props.multipleTimeEntries &&
                !props.isQueryPage &&
                !props.isListView &&
                (!isImportedFromChangeGearOrBamboo ||
                  (isImportedFromChangeGearOrBamboo &&
                    deletableFromBambooSuperAdmin)) &&
                !props.partialInactiveEntryProjectWorkOrder &&
                !disabledByTimeViewer &&
                iconDeleteEnabled(
                  props.activeEntry,
                  activeUserId,
                  props.userIdParam,
                  isSuperTimeAdmin,
                  isSupervisorOrPO,
                  isDeliveryTimeAdmin,
                  isTimeViewer,
                  previousWorkableDay,
                  today,
                  lastWorkableDay,
                ) && (
                  <div
                    role="button"
                    tabIndex={0}
                    className="delete-button mt-2"
                    onClick={() => props.deleteEntry(props.activeEntry)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        props.deleteEntry(props.activeEntry);
                      }
                    }}
                  >
                    Delete
                  </div>
                )}
            </div>
            <div>
              <div className="d-flex">
                {(isHolidayFromBamboo || isImportedFromChangeGearOrBamboo) &&
                  actualSourceUrl &&
                  isImportedFromChangeGearOrBambooText !== CHANGE_GEAR && (
                    <Link
                      to={actualSourceUrl}
                      className="entry-text-imported text-decoration-none mt-3 me-5 other-links-hover"
                    >
                      From {isImportedFromChangeGearOrBambooText}
                    </Link>
                  )}
                {(isHolidayFromBamboo || isImportedFromChangeGearOrBamboo) &&
                  (!actualSourceUrl ||
                    isImportedFromChangeGearOrBambooText === CHANGE_GEAR) && (
                    <div className="entry-text-imported link-black mt-3 me-5">
                      From {isImportedFromChangeGearOrBambooText}
                    </div>
                  )}
                <button
                  tabIndex={0}
                  className="btn button-secondary w-25"
                  onClick={props.btnCancel}
                >
                  Cancel
                </button>

                <button
                  tabIndex={0}
                  className="btn btn-primary w-25 ms-3"
                  disabled={setSaveDisabled()}
                  onClick={() => clickHandler()}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      {props.multipleTimeEntries && (
        <form className={`card entry-hour-box-background px-4 py-2 ${
          !props.isModal ? "my-3" : ""
        }`}>
          <div className="row">
            <div className="d-flex">
              <div className="border-dark fw-500 ps-2 column-10">Date</div>
              <div className="border-dark fw-500 ps-2 column-10">Time</div>
              <div className="border-dark fw-500 ps-2 column-15">Type</div>
              <div className="border-dark fw-500 ps-2 column-55">
                Description
              </div>
              <div className="border-dark fw-500 text-center py-0 ps-2 column-10"></div>
            </div>
          </div>
          {props.multipleTimeEntries.map((entry: TimeEntrySheetView) => {
            return (
              <div className="row mt-1" key={entry.timeEntryId}>
                <div className="d-flex table-row-multiple-entries">
                  <div className="column-10 fw-500 py-1 ps-2">
                    {dateFormatEntryEdit(entry.entryDate)}
                  </div>
                  <div className="column-10 fw-500 py-1 ps-2">
                    {`${entry.hours.toFixed(2)} hours`}
                  </div>
                  <div className="column-15 fw-500 py-1 ps-2">
                    {getValueFromSelect(
                      MetaTimesInfo.taskTypes,
                      entry.taskTypeId,
                    )
                      ? getValueFromSelect(
                          MetaTimesInfo.taskTypes,
                          entry.taskTypeId,
                        ).label
                      : entry.taskType}
                  </div>
                  <div className="column-55 fw-500 py-1 ps-2">
                    <div className="entry-description">
                      {decodeURIComponentSafe(entry.description)}
                    </div>
                  </div>
                  <div className="d-flex column-10 justify-content-center py-1 ps-2" style={{ pointerEvents: "auto" }}>
                    <BiEditAlt
                      className="icon-entry-action me-2"
                      style={{ cursor: "pointer", pointerEvents: "auto" }}
                      onClick={(e) => {e.stopPropagation(); updateInfoModal(entry);}}
                    />
                    <BiTrash
                      className={`icon-entry-action ${
                        iconDeleteEnabled(
                          entry,
                          activeUserId,
                          props.userIdParam,
                          isSuperTimeAdmin,
                          isSupervisorOrPO,
                          isDeliveryTimeAdmin,
                          isTimeViewer,
                          previousWorkableDay,
                          today,
                          lastWorkableDay,
                        ) &&
                        !props.partialInactiveEntryProjectWorkOrder &&
                        !disabledByTimeViewer
                          ? ""
                          : "disabled"
                      }`}
                      style={{ cursor: "pointer", pointerEvents: "auto" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          iconDeleteEnabled(
                            entry,
                            activeUserId,
                            props.userIdParam,
                            isSuperTimeAdmin,
                            isSupervisorOrPO,
                            isDeliveryTimeAdmin,
                            isTimeViewer,
                            previousWorkableDay,
                            today,
                            lastWorkableDay,
                          ) &&
                          !props.partialInactiveEntryProjectWorkOrder &&
                          !disabledByTimeViewer
                        ) {
                          props.deleteEntry(entry);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </form>
      )}

      <form
        className={`card entry-hour-box-background px-4 py-2 ${
          !props.isModal ? "my-3" : ""
        }`}
      >
        {props.title && (
          <div className="row">
            <h4>{props.title}</h4>
          </div>
        )}
        
        {props.isModal ? (
          <FocusTrap
            active={!props.isModalDeleteOpen}
            focusTrapOptions={{
              initialFocus: () => "#InputNumberHours",
              clickOutsideDeactivates: true,
            }}
          >
            {modalContent}
          </FocusTrap>
        ) : (
          <div>{modalContent}</div>
        )}
      </form>
    </>
  );
};
